import { mapActions, mapState } from 'vuex';
import funcoes from '../../util/funcoes'

import { STATUS_LANCAMENTO } from "../../util/constantes";
import AppSelecionarContaDialog from '../../shared/dialogs/SelecionarContaDialog.vue'
import AppSelecionarContaBancariaDialog from '../../shared/dialogs/SelecionarContaBancariaDialog.vue'

export default {
  components: {
    AppSelecionarContaDialog,
    AppSelecionarContaBancariaDialog
  },

  data() {
    return {
      tabSelecionada: 'remessas',
      visibilidadeSelecionarContaDialog: false,
      visibilidadeSelecionarContaBancariaDialog: false,

      remessa: {
        dataInicio: funcoes.primeiroDiaMes(),
        dataFim: funcoes.ultimoDiaMes(),
        tipoData: 'DATA_VENCIMENTO'       
      },

      conta: {id: 0, contaPlanoConta: {nome: ''} },
      contaBancaria: { nome: undefined },

      validacao: {
        dataInicio: [{ required: true, len: 10 }],
        dataFim: [{ required: true, len: 10 }]
      },
      loadingPlanos: false,
    }
  },
  
  computed:{
    ...mapState('remessasBancariasFinanceiroStore',{
      listaLancamentos(state) { return state.lancamentos },
      planos(state) { return state.planos },
    }),

    labelConta() {
      if(this.conta) {
        return `${this.conta.contaPlanoConta.nome ? this.conta.contaPlanoConta.nome : ""}${this.conta.valor ? ', valor: R$ ' + this.conta.valor : ''}`
      } else {
        return ''
      }
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('remessasBancariasFinanceiroStore', [
      'listarLancamentos',
      'recuperarNumeroRemessa',
      'gerarRemessa',
      'selecionarTodos',
      'deselecionarTodos',
      'listarPlanos'
    ]),

    listarLancamentosHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.showLoading();

          const payload = {
            contaBancaria: this.contaBancaria,
            conta: this.conta,
            tipoData: this.remessa.tipoData, 
            dataInicio: this.remessa.dataInicio,
            dataFim: this.remessa.dataFim
          }

          this.listarLancamentos(payload)
          .then()
          .finally(() => {
            this.hideLoading();
          })
        } else {
          this.$message.warning("Preencha os campos obrigatórios")
        }
      })
    },

    recuperarNumeroRemessaHandler() {
      let selecionados = this.listaLancamentos.filter(item => { return item.selecionado }).length
      if(selecionados === 0){
        this.$message.warning("Nenhum recibo selecionado!");
        return;
      }
      
      this.showLoading();

      let payload = { id: this.contaBancaria.id }

      this.recuperarNumeroRemessa(payload)
        .then(resultado => {
          this.hideLoading()
          
          switch (resultado.status) {
            case 'SUCESSO':
              this.$confirm("Deseja gerar a remessa Nº " + resultado.item + "?", "Atenção", {
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                type: "warning"
              }).then(() => {
                this.gerarRemessaHandler(resultado.item)
              });
              break;
            default:
             this.$message.warning("Não foi possível recuperar o número da remessa");
             break;
          }
        })
        .catch(() => {
          this.hideLoading()
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    gerarRemessaHandler(numeracaoRemessa) {
      this.showLoading()

      let payload = {}
      let lancamentos = []

      lancamentos = this.listaLancamentos.filter(item => { return item.selecionado })
      lancamentos = lancamentos.map(item => { return item.id })
      
      payload = {
        lancamentos: lancamentos,
        idContaBancaria: this.contaBancaria.id,
        idConta: this.conta.id,
        numeracaoRemessa: numeracaoRemessa
      }
      
      this.gerarRemessa(payload)
        .then(resultado => {
          const url = window.URL.createObjectURL(new Blob([resultado.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', this.contaBancaria.banco === 'SICRED' ?  this.gerarNomeArquivoRemessaSicredi() : this.contaBancaria.banco === 'INTER' ? this.gerarNomeArquivoInter(numeracaoRemessa) : 
            numeracaoRemessa+'.rem')
          document.body.appendChild(link)
          link.click()

          this.hideLoading()
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    filtrarContaSelect(queryString) {
      let payload = { id: 0, status: 'ABERTA', contaPlanoConta: {nome: queryString, grupoPlanoConta: { tipo: 'RECEITA' }} }
      this.loadingPlanos = true;
      this.listarPlanos(payload)
      .then(() => {
      this.loadingPlanos = false;  
      })
    },

    limparConta() {
      this.conta = { contaPlanoConta: {nome: undefined} }
    },

    exibirSelecionarContaBancariaDialog() {
      this.visibilidadeSelecionarContaBancariaDialog = true
    },

    fecharSelecionarContaBancariaDialog(contaBancaria) {
      this.contaBancaria = contaBancaria
      this.visibilidadeSelecionarContaBancariaDialog = false
    },

    exibirSelecionarContaDialog() {
      this.visibilidadeSelecionarContaDialog = true
    },

    fecharSelecionarContaDialog(conta) {
      this.conta = conta
      this.visibilidadeSelecionarContaDialog = false
    },

    formatarValor(item){
      return funcoes.formatarValor(item.valor)
    },

    storeLocalStorage(day, sequencial) {
      localStorage.setItem("dia", day);
      localStorage.setItem("sequencial", sequencial);
    },

    getDiaDaRemessa() {
        let diaDaRemessa = localStorage.getItem("dia");
        return diaDaRemessa
    },

    getSequencialDaRemessa() {
        let senquencialDaRemessa = localStorage.getItem("sequencial")
        return senquencialDaRemessa;
    },
    
    gerarNomeArquivoRemessaSicredi() {
        let sequencialDaRemessa = this.getSequencialDaRemessa();
        let diaDaRemessa = this.getDiaDaRemessa();

        let nomeArquivo = "";

        const today = new Date();
    
        const month = today.getMonth() + 1;

        const day = today.getDate();
        
        if(parseInt(diaDaRemessa) !== day) {
            this.storeLocalStorage(day, 0);
            sequencialDaRemessa = this.getSequencialDaRemessa();
            diaDaRemessa = this.getDiaDaRemessa();
        }

        if(parseInt(diaDaRemessa) === day) {
            let sequencialDaRemessaInt = parseInt(sequencialDaRemessa);
            this.storeLocalStorage(day, sequencialDaRemessaInt += 1);
            sequencialDaRemessa = this.getSequencialDaRemessa();
            diaDaRemessa = this.getDiaDaRemessa();
        }
        
        let sequencialDaRemessaInt = parseInt(sequencialDaRemessa);

        nomeArquivo += this.contaBancaria.agencia + `${
        month === 10 ? 'O' : month === 11 ? 'N' : month === 12 ? 'D' : month}` + (day < 10 ? '0' + day : day) + `${
            parseInt(sequencialDaRemessa) === 1 ? '.CRM' : `${parseInt(sequencialDaRemessa) < 10 ? '.00' + (sequencialDaRemessaInt - 1) : '.0' + (sequencialDaRemessaInt - 1)}`
        }`;

        return nomeArquivo;
    },

    gerarNomeArquivoInter(numeroRemessa) {
      let nomeArquivo = `CI400_001_${funcoes.addZerosAEsquerda(numeroRemessa, 7)}.REM`
      return nomeArquivo;
    },
    getLabelStatus(item) {
      return funcoes.getLabel(STATUS_LANCAMENTO,item.status)
    },
    formatarIconStatus(item) {
      switch (item) {
        case 'ABERTO':
          return '#4B6EF6'; 
        case 'EFETUADO':
          return '#2DB748';
        case 'DEVOLVIDO':
          return '#FF9E29';
        case 'CANCELADO':
          return '#DF1B1B';
      }
    }
  },
}